import { createService } from "@/Services/BaseService";

const OperationelService = createService("Operationel");

// databaseDisplayName, when set, scopes the stats to a single database; left
// blank the backend aggregates every database the user can access. It is part
// of the URL so each database gets its own cache entry.
export function getJobStats(startDate, endDate, forceUpdate = false, databaseDisplayName) {
  return OperationelService.getWithDateRange("/JobStats", startDate, endDate, {
      cache: true,
      cacheDuration: 24 * 60 * 60 * 1000,
      forceUpdate
    }, { databaseDisplayName });
}

export function getQueueStats(startDate, endDate, forceUpdate = false, databaseDisplayName) {
  return OperationelService.getWithDateRange(
    "/QueueStats",
    startDate,
    endDate,
    {
      cache: true,
      cacheDuration: 24 * 60 * 60 * 1000, // 24 hours
      forceUpdate
    },
    { databaseDisplayName }
  );
}